const USDT_DETAIL_LOADING = 'USDT_DETAIL_LOADING';
const USDT_DETAIL_SUCCESS = 'USDT_DETAIL_SUCCESS';
const USDT_DETAIL_FAILURE = 'USDT_DETAIL_FAILURE';

export const usdtDetailActions = {
  USDT_DETAIL_LOADING,
  USDT_DETAIL_SUCCESS,
  USDT_DETAIL_FAILURE,
};
